<template>
	<div class="search-machine-advert-group">
		<div class="el-search vue-top-padding radius">
			<div class="el-left">
				<el-button
					type="primary"
					size="small"
					v-hasPerm="['machine:advert:group:insert']"
					icon="el-icon-plus"
					@click="addMachineAdvertGroup"
					>{{ $t("common.add") }}</el-button
				>
			</div>
			<div class="el-right">
				<el-form
					ref="machineAdvertGroup"
					:model="search"
					:inline="true"
					label-width="10px"
					size="small"
					class="demo-form-inline el-input-height"
				>
					<el-form-item prop="userName">
						<el-input
							v-model="search.userName"
							:placeholder="$t('searchMachineAdvertGroup.userName')"
						></el-input>
					</el-form-item>
					<el-form-item prop="adTeamName">
						<el-input
							v-model="search.adTeamName"
							:placeholder="$t('searchMachineAdvertGroup.advertGroupName')"
						></el-input>
					</el-form-item>
					<el-form-item prop="userEquipmentLabelTeamName">
						<el-input
							v-model="search.userEquipmentLabelTeamName"
							placeholder="Label Name"
						></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onSubmit" icon="el-icon-search">{{
							$t("common.search")
						}}</el-button>
						<el-button
							@click="resetSearch('machineAdvertGroup')"
							icon="el-icon-refresh"
							>{{ $t("common.reset") }}</el-button
						>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "SearchMachineAdvertGroup",
	props: {
		search: Object,
	},
	methods: {
		addMachineAdvertGroup() {
			this.$emit("addMachineAdvertGroup");
		},
		onSubmit() {
			this.$emit("onSubmit", this.search);
		},
		resetSearch(formName) {
			this.$refs[formName].resetFields();
			this.$toolUtil.clearForm(this.search);
			this.$emit("resetSearch", this.search);
		},
	},
};
</script>

<style scoped></style>
